import React from 'react';

import { Box, Group, Text, useMantineTheme } from '@mantine/core';

import { resolveCardVisuals } from './resolveCardVisuals';
import WorkoutVisibilityIcon from '../../WorkoutVisibilityIcon';
import type { AthleteCalendarItem } from '../types';

interface MonthChipProps {
  item: AthleteCalendarItem;
}

/** Mobiscroll sizes each label row and spaces the rows itself, so the chip must not outgrow its row. */
const MonthChip = ({ item }: MonthChipProps): JSX.Element => {
  const theme = useMantineTheme();
  const { accent, tint, fill, foreground, isCompleted, isHidden } = resolveCardVisuals(item, theme);

  return (
    <Box
      data-cy={`athleteCalendarChip-${item.kind}`}
      data-source={item.kind === 'workout' ? item.source : undefined}
      sx={{
        backgroundColor: fill ?? (isCompleted ? tint : theme.colors.gray[1]),
        borderLeft: `3px solid ${accent}`,
        borderRadius: theme.radius.sm,
        boxSizing: 'border-box',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '0 6px',
        cursor: 'pointer',
        overflow: 'hidden',
      }}
    >
      <Group spacing={4} noWrap sx={{ flex: 1, minWidth: 0 }}>
        <Text size='xs' fw={600} truncate lh={1.2} sx={{ color: foreground, flex: 1, minWidth: 0 }}>
          {item.name}
        </Text>
        {isHidden && <WorkoutVisibilityIcon visible={false} withinPortal />}
      </Group>
    </Box>
  );
};

export default MonthChip;
